import { Global, Jobs, JobsCategory } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import Newsletter from '../../components/Newsletter';
import JobDetails from '../../components/JobDetails';
import MainBanner from '../../components/MainBanner';
import GoogleJobSchema from "../../components/GoogleJsonData";

export default function JobsPage({
  global,
  page,
  similar_jobs,
  job_type
}) {
  return (
    <>
      <SeoHead
        page_name={`${page.title} in ${page.location} | Carbon60`}
        description={`Apply for ${page.title} in ${page.location} with Carbon60, specialists in Engineering.`}
        canonical_link={`jobs/${page.url_slug}`}
      />
      <MainBanner
        global={global}
        pathPrefix={`job_page.main_banner`}
        customClass={``}
        content={``}
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
      />
      <JobDetails
        global={global}
        pathPrefix={`job_page.job_details`}
        customClass={`position-relative mb-5`}
        post={page}
        buttonTitle={`Back to previous page`}
        buttonLink={`/jobs/`}
        job={page}
        job_type={job_type}
        jobId={`${page.id}`}
        successPageUrl={`/jobs/thank-you-for-applying/`}
        content={
          <>
            <h2>Apply to this Job</h2>
          </>
        }
        share_job_content={
          <p><strong>Share this Job</strong></p>
        }
        similar_jobs={similar_jobs}
      />
      <Newsletter
        global={global}
        pathPrefix={`job_page.newsletter`}
        customClass={`py-5 blueGradientBg`}
        content={
          <>
            <h2>More Informations</h2>
          </>
        }
        content_2={null}
        formId={`6dfe644a-5f46-4e5d-9ba8-be0b6c0583c4`}
        successPageUrl={`/jobs/subscription-success/`}
        buttonTitle={`Insights`}
        buttonLink={`/blog/`}
        buttonTitle2={`Similar Roles`}
        buttonLink2={`/`}
      />
      <GoogleJobSchema
        job={page}
        job_type={job_type}
        job_currency={`GBP`}
        job_payment_type={`YEAR`}
        job_country={`United Kingdom`}
        site_name={`Carbon60`}
        site_domain_link={`https://www.carbon60global.com/`}
        site_google_logo_link={`https://www.carbon60global.com/site-assets/images/google-image.jpg`}
        site_domain_jobs_link={`https://www.carbon60global.com/jobs`}
      />
    </>
  )
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const page = (await Jobs()).getJsonItem(params.slug, 'url_slug');

  if (!page) {
    return { notFound: true };
  }

  const currentjob = await Jobs();
  const internalcategory = currentjob.getItems().find(j => j.url_slug === params.slug);
  // Checks sector category
  const getIndexedValues = async function (categoryName) {
    const category = await JobsCategory(categoryName)
    return [category, category.items.reduce((previous, value) => ({ [value.id]: value, ...previous }), {})]
  }
  const jobTypeCategory = await getIndexedValues('Job Type');

  const jobTypeSectorIds = internalcategory.categories.find((cat) => cat.id === jobTypeCategory[0].id)?.values || []

  const jobType = jobTypeSectorIds.map((jobtype, index) => jobTypeCategory[1][jobtype.id] ? jobTypeCategory[1][jobtype.id].title?.en + `${jobTypeCategory.length > 1 ? `${index === jobTypeSectorIds.length - 1 ? "" : ", "}` : ""}` || null : null);

  // Get similar jobs
  const sectorCategory = await getIndexedValues("Job Sectors");

  const jobSectorIds =
    internalcategory.categories.find((cat) => cat.id === sectorCategory[0].id)
      ?.values || [];

  const targetSectorName = jobSectorIds[0]?.title; // Change this to the sector name you want to filter by

  let similar_jobs;

  similar_jobs = (await Jobs())
    .getItems()
    .filter((post) =>
      post.url_slug !== page.url_slug &&
      post.categories
        ?.find((cat) => cat.title === "Job Sectors")
        ?.values?.some((value) => value.title.includes(targetSectorName))
    )
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .slice(0, 3);

  return {
    props: {
      global,
      page,
      similar_jobs,
      job_type: jobType,
    }
  };
}

export async function getStaticPaths() {
  const jobs = await Jobs();
  const jobsSlugs = jobs.map('url_slug').getItems();

  const paths = jobsSlugs.map((jobSlug) => ({
    params: { slug: jobSlug },
  }))
  return { paths, fallback: 'blocking' }
}